import jp from 'jsonpath/jsonpath.min';

export function getQuestionPath(id) {
    return `$..[?(@.definisjon=="${id}")]`;
}

export function getAnswerPath(id) {
    return `muligeSvar[?(@.svarId=="${id}")]`;
}

export function getAnswer(id, question) {
    const path = getAnswerPath(id);
    return jp.query(question, path)[0];
}

export function getQuestion(id, skjema) {
    const path = getQuestionPath(id);
    return jp.query(skjema, path)[0];
}
